import { cloneDeep } from 'lodash';
import { formatApplicationSummary } from './applicationSummaryHelper';
import { getQuestionAnswers } from 'shared/utils/FormatHelper';
import {
  PlantItemConstants,
  PlantItemNewOngoingContactTypes as OngoingContactTypes,
} from 'plantItemNew/constants/plantItemConstants';
import { PHONE_TYPES } from 'shared/utils/PhoneNumber';
import { RegistrationHolderTypes } from 'shared/constants/registrationHolderTypes';

const isSectionCompleted = (arr) => {
  let isCompleted = false;
  if (arr && arr.length > 0) {
    for (let i in arr) {
      if (arr[i].finished == false) {
        isCompleted = false;
        break;
      }
      isCompleted = true;
    }
  } else {
    isCompleted = true;
  }

  return isCompleted;
};

const formatAddressForLabel = (address) => {
  if (address && address.enterManually && !address.international) {
    return `${address.addressLine}, ${address.suburb}, ${address.state.label}, ${address.postcode}`;
  } else if (address && address.lookupValue && address.lookupValue.label) {
    return address.lookupValue.label;
  } else {
    return `${address.addressLine}, ${address.suburb}, ${address.state ? address.state + ',' : ''} ${
      address.postcode
    }, ${address.country}`;
  }
};

const objOfJsonArrayItem = (arrObjects, key, value) => {
  let obj = {};
  arrObjects.map((el) => {
    if (el[key] && value && el[key].toLowerCase() == value.toLowerCase()) {
      obj = el;
    }
  });

  return obj;
};

const getContactDetailsSubmission = (applicantDetails, holderDetails) => {
  let email = '';
  let mobileNumber = '';
  let landlineNumber = '';

  let phoneNumber = null;

  if (holderDetails?.ongoingContact?.contactType === OngoingContactTypes.someoneElse.value) {
    email = holderDetails?.ongoingContact?.emailAddress;
    phoneNumber = holderDetails?.ongoingContact?.phoneNumber;
  } else if (holderDetails?.ongoingContact?.contactType === OngoingContactTypes.me.value) {
    email = applicantDetails?.emailAddress;
    if (
      holderDetails?.amIRegistrationHolder &&
      holderDetails?.registrationType === RegistrationHolderTypes.individual
    ) {
      phoneNumber = holderDetails?.phoneNumber;
    } else {
      phoneNumber = holderDetails?.ongoingContact?.phoneNumber;
    }
  } else if (holderDetails?.ongoingContact?.contactType === OngoingContactTypes.registrationHolder.value) {
    email = holderDetails?.emailAddress;
    phoneNumber = holderDetails?.phoneNumber;
  }

  if (phoneNumber?.type === PHONE_TYPES.MOBILE) {
    mobileNumber = phoneNumber?.formattedNumber;
  } else if (phoneNumber?.type === PHONE_TYPES.LANDLINE) {
    landlineNumber = phoneNumber?.formattedNumber;
  }

  return {
    email,
    mobileNumber,
    landlineNumber,
  };
};

// const getKeyContactDetails = (applicantDetails, holderDetails) => {
//   let firstName = '';
//   let middleName = '';
//   let lastName = '';
//   let abnOrBusinessName = '';
//   let email = '';
//   let primaryContactNumber = '';
//   let secondaryContactNumber = '';

//   if (holderDetails?.ongoingContact?.contactType === OngoingContactTypes.someoneElse) {
//     firstName = holderDetails?.ongoingContact?.firstName;
//     middleName = holderDetails?.ongoingContact?.middleName;
//     lastName = holderDetails?.ongoingContact?.lastName;
//     abnOrBusinessName = holderDetails?.ongoingContact?.businessName;
//     email = holderDetails?.ongoingContact?.emailAddress;
//     primaryContactNumber = getHolderPrefferedLandlineNumber(holderDetails);
//     secondaryContactNumber = getHolderPrefferedLandlineNumber(holderDetails);
//   } else if (holderDetails?.ongoingContact?.contactType === OngoingContactTypes.me) {
//     firstName = applicantDetails?.firstName;
//     middleName = applicantDetails?.middleName;
//     lastName = applicantDetails?.lastName;
//     email = applicantDetails?.emailAddress;
//     primaryContactNumber = applicantDetails.phoneNumberPrimary.formattedNumber;
//     secondaryContactNumber = applicantDetails?.phoneNumberSecondary?.formattedNumber;
//   } else if (holderDetails?.ongoingContact?.contactType === 'owner') {
//     firstName = holderDetails?.firstName;
//     middleName = holderDetails?.middleName;
//     lastName = holderDetails?.lastName;
//     email = holderDetails?.emailAddress;
//     primaryContactNumber = getHolderPrefferedMobileNumber(holderDetails);
//     secondaryContactNumber = getHolderPrefferedLandlineNumber(holderDetails);
//   }

//   return {
//     firstName,
//     middleName,
//     lastName,
//     abnOrBusinessName,
//     email,
//     primaryContactNumber,
//     secondaryContactNumber,
//   };
// };

const formattedJsonToSubmit = (
  application,
  duration,
  applicantDetails,
  holderDetails,
  plantItems,
  referenceData,
  declaration,
) => {
  let formattedJson = {
    applicationId: application.applicationId,
    licenceType: application.licenceType,
    applicationNo: application.applicationNo,
    applicantType: 'individual',
    plantTransactionType: PlantItemConstants.transactionType,
    SnswServiceActivated: false,
    durationRequested: duration.replace('Years', '').replace('Year', '').trim(),
    ...(holderDetails.registrationType === RegistrationHolderTypes.individual &&
      formattedIndividualApplicant(applicantDetails, holderDetails, referenceData)),
    ...(holderDetails.registrationType === RegistrationHolderTypes.organisation &&
      formattedOrganisationApplicant(applicantDetails, holderDetails, referenceData)),
    questionList: [
      {
        questionGroupDescription: 'Disclosures',
        questionAnswers: getQuestionAnswers(),
      },
    ],
    attachments: [],
    premisesList: formatPremisesList(plantItems, holderDetails?.organisation?.selectedBusinessName),
    contactDetails: [getContactDetailsSubmission(applicantDetails, holderDetails)],
    plantItems: formattedPlantItems(plantItems),
    itemCount: plantItems.items.length,
    employer: applicantDetails.employer,
    applicationSummary: formatApplicationSummary(applicantDetails, holderDetails, plantItems, declaration),
    jobTitle: applicantDetails.jobTitle,
  };

  return formattedJson;
};

const formatAddresses = (holderDetails, addressType, addressTypeId, addressTypes) => {
  let mailingAddressType = addressTypes.find((ad) => ad.description === 'Mailing');

  let addresses = [
    {
      addressType: addressType,
      addressTypeID: addressTypeId,
      enterManually: holderDetails.address.enterManually ?? false,
      manualAddress: formatManualAddress(holderDetails.address, true),
      lookupValue: holderDetails.address.lookupValue,
      details: getAddressDetails(holderDetails.address, true),
    },
  ];

  if (holderDetails.mailingAddress?.details || holderDetails.mailingAddress?.enterManually) {
    addresses.push({
      addressType: 'Mailing',
      addressTypeID: mailingAddressType.code ? parseInt(mailingAddressType.code) : 10,
      enterManually: holderDetails.mailingAddress.enterManually ?? false,
      manualAddress: formatManualAddress(holderDetails.mailingAddress, false),
      lookupValue: holderDetails.mailingAddress.lookupValue,
      details: getAddressDetails(holderDetails.mailingAddress, false),
    });
  }

  return addresses;
};

const getAddressDetails = (address, isPrimary) => {
  if (address.enterManually === true) return null;

  return {
    Address: {
      ...address.details.Address,
      isPrimary,
    },
    Status: address.details.Status,
  };
};

const formattedPlantItems = (plantItems) => {
  const items = {
    boilers: [],
    pressureVessels: [],
    lifts: [],
    escalators: [],
    movingWalkways: [],
    amusementDevices: [],
    mobileCranes: [],
    towerCranes: [],
    buildingMaintenanceUnits: [],
    concretePlacingBooms: [],
    reasonToRegister: plantItems.reasonToRegister,
  };

  let copiedItems = cloneDeep(plantItems.items);

  if (Array.isArray(plantItems?.items) && plantItems?.items?.length > 0) {
    copiedItems.forEach((item) => {
      switch (item.itemDetails.itemType) {
        case '1':
          items.boilers.push(item);
          break;
        case '2':
          items.pressureVessels.push(item);
          break;
        case '3':
          items.lifts.push(item);
          break;
        case '4':
          items.escalators.push(item);
          break;
        case '5':
          items.movingWalkways.push(item);
          break;
        case '6':
          delete item.relatedDetails?.electricalInspectionDetails?.uploadedFiles;
          delete item.relatedDetails?.engineerInspectionDetails?.uploadedFiles;
          items.amusementDevices.push(item);
          break;
        case '7':
          items.mobileCranes.push(item);
          break;
        case '8':
          delete item.relatedDetails?.inspectionDetails?.uploadedFiles;
          items.towerCranes.push(item);
          break;
        case '9':
          items.buildingMaintenanceUnits.push(item);
          break;
        case '10':
          items.concretePlacingBooms.push(item);
          break;
      }
    });
  }
  return items;
};

const formattedIndividualApplicant = (applicantDetails, holderDetails, referenceData) => {
  let addressTypes = referenceData.data.addressType;
  let residentialAddressType = addressTypes.find((ad) => ad.description === 'Residential');

  let data = {
    individualApplicantDetails: {
      roles: ['Applicant'],
      id: 'applicant1',
      firstName: applicantDetails.firstName,
      middleName: applicantDetails.middleName,
      surname: applicantDetails.lastName,
      email: applicantDetails?.emailAddress,
      contactPart: {
        // This emailAddress is required for sending email confirmation.
        emailAddress: applicantDetails.emailAddress,
      },
    },
  };

  const addressTypeId = residentialAddressType?.code ? parseInt(residentialAddressType.code) : 40;

  if (holderDetails.amIRegistrationHolder) {
    data.individualApplicantDetails.addresses = formatAddresses(
      holderDetails,
      'Residential',
      addressTypeId,
      addressTypes,
    );
    data.individualApplicantDetails.mobileNumber = getHoldersMobileNumber(holderDetails);
    data.individualApplicantDetails.contactPart.phoneNo = getHolderLandlineNumber(holderDetails);
  } else if (holderDetails.amIRegistrationHolder === false) {
    data.associatedIndividuals = [
      {
        roles: ['Registration holder'],
        id: 'Registration holder',
        firstName: holderDetails.firstName,
        middleName: holderDetails.middleName,
        surname: holderDetails.lastName,
        email: holderDetails.emailAddress,
        mobileNumber: getHoldersMobileNumber(holderDetails),
        addresses: formatAddresses(holderDetails, 'Residential', addressTypeId, addressTypes),
      },
    ];
  }

  return data;
};

const formattedOrganisationApplicant = (applicantDetails, holderDetails, referenceData) => {
  let addressTypes = referenceData.data.addressType;
  let registeredAddressType = addressTypes.find((ad) => ad.description === 'Registered');

  const residentialAddressTypeId =
    registeredAddressType && registeredAddressType.code ? parseInt(registeredAddressType.code) : 70;

  return {
    individualApplicantDetails: {
      roles: ['Applicant'],
      id: 'applicant1',
      firstName: applicantDetails.firstName,
      middleName: applicantDetails.middleName,
      surname: applicantDetails.lastName,
      email: applicantDetails.emailAddress,
      // mobileNumber: applicantDetails.phoneNumberPrimary.formattedNumber,
    },
    organisationApplicantDetails: {
      id: 'corp0',
      abn: holderDetails?.organisation?.abn,
      name: holderDetails?.organisation?.organisationName,
      registeredBusinessName: holderDetails?.organisation?.selectedBusinessName,
      acn: holderDetails?.organisation?.acn,
      phoneNumber: holderDetails.phoneNumber.formattedNumber,
      emailAddress: holderDetails.emailAddress,
      addresses: formatAddresses(holderDetails, 'Registered', residentialAddressTypeId, addressTypes),
    },
  };
};

const formatPremisesList = (plantItems, businessName) => {
  let data = [
    {
      businessName: businessName,
      premiseAddresses: [
        {
          addressType: 'Premise',
          addressTypeID: 7,
          enterManually:
            plantItems.location && plantItems.location.enterManually ? plantItems.location.enterManually : false,
          manualAddress: plantItems.location && formatManualAddress(plantItems.location),
          lookupValue: plantItems.location && plantItems.location.lookupValue,
          details:
            plantItems.location && plantItems.location.enterManually === true
              ? null
              : plantItems.location && plantItems.location.details,
        },
      ],
    },
  ];

  return data;
};

const formatManualAddress = (address, isPrimary) => {
  let manualAddress = {};
  if (address && address.enterManually === true) {
    manualAddress.addressLine = address.addressLine;
    manualAddress.suburb = address.suburb;
    manualAddress.state = address.state.text;
    manualAddress.postCode = address.postcode;
    manualAddress.country = 'AUSTRALIA';
    manualAddress.isPrimary = isPrimary && isPrimary === true ? true : null;
  }

  return manualAddress;
};

const getHoldersMobileNumber = (holderDetails) => {
  if (holderDetails.phoneNumber?.type !== PHONE_TYPES.MOBILE) return;

  return holderDetails.phoneNumber.formattedNumber;
};

const getHolderLandlineNumber = (holderDetails) => {
  if (holderDetails.phoneNumber?.type !== PHONE_TYPES.LANDLINE) return;

  return holderDetails.phoneNumber.formattedNumber;
};

export {
  formatAddressForLabel,
  getContactDetailsSubmission,
  objOfJsonArrayItem,
  isSectionCompleted,
  formattedJsonToSubmit,
};
